import { Component, inject, Input } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-game-title',
  templateUrl: './game-title.component.html',
  styleUrls: ['./game-title.component.scss'],
})
export class GameTitleComponent {
  @Input({ required: true }) title!: string;
  private themeService = inject(ThemeService);

  get capitalize(): boolean {
    return this.themeService.gameTitleConfig().capitalize;
  }

  get glowClass(): string {
    return this.themeService.gameTitleConfig().hasOutlineGlow ? 'outline-glow' : 'no-outline-glow';
  }
}
